import { useMutation, useQuery } from "@apollo/client";
import CircularProgress from "@mui/material/CircularProgress";
import { List } from "../../List/List";
import { Popconfirm } from "../../Overlay/Overlay";
import { Typography } from "../../Typography/Typography";
import { DeleteOutline as DeleteOutlined } from "@mui/icons-material";
import { GET_STORED_PROMPTS_LIST } from "../../ChatBox/graphql";
import { DELETE_STORED_PROMPT } from "../graphql";
import { useRangerChatStore } from "../chatStore";

const { Text } = Typography;

export function PromptsTab() {
  const { data, loading, refetch } = useQuery(GET_STORED_PROMPTS_LIST, {
    variables: { filter: {} },
  });
  const [deletePrompt] = useMutation(DELETE_STORED_PROMPT);
  const patchActiveSlot = useRangerChatStore(s => s.patchActiveSlot);
  const setUserText = (text: string) => patchActiveSlot({ userText: text });
  const setMenuOpen = useRangerChatStore(s => s.setMenuOpen);

  if (loading) return <CircularProgress size={16} />;

  const prompts = data?.storedPromptsList?.items ?? [];

  if (prompts.length === 0) {
    return (
      <Text type="secondary" style={{ fontSize: 12 }}>
        No saved prompts. Type a message and click the save button to save it
        for later.
      </Text>
    );
  }

  return (
    <List
      size="small"
      dataSource={prompts}
      renderItem={(item: any) => (
        <List.Item
          style={{ cursor: "pointer", padding: "4px 0" }}
          onClick={() => {
            setUserText(item.prompt);
            setMenuOpen(false);
            // Re-focus the sidebar so it stays expanded after the popover closes
            requestAnimationFrame(() => {
              document.getElementById("main-sidebar")?.focus();
            });
          }}
        >
          <div style={{ display: "flex", alignItems: "center", width: "100%", gap: 4 }}>
            <Text ellipsis style={{ fontSize: 12, flex: 1 }}>
              {item.prompt}
            </Text>
            <Popconfirm
              title="Delete this prompt?"
              onConfirm={async e => {
                e?.stopPropagation();
                await deletePrompt({ variables: { id: item.id } });
                refetch();
              }}
              onCancel={e => e?.stopPropagation()}
              okText="Delete"
              cancelText="Cancel"
            >
              <DeleteOutlined
                onClick={e => e.stopPropagation()}
                style={{ fontSize: 12, color: "#999", flexShrink: 0 }}
              />
            </Popconfirm>
          </div>
        </List.Item>
      )}
    />
  );
}
